<template>
    <div class="settingsPage">
        <h1>{{$t('title')}}</h1>
        <b-card no-body>
            <b-tabs card @input="changeTab" v-model="tabIndex">
                <b-tab :title="$t('general.title')">
                    <general-settings></general-settings>
                </b-tab>
                <b-tab :title="$t('passwords.title')" v-if="canChangePassword">
                    <passwords></passwords>
                </b-tab>
                <b-tab :title="$t('sending.title')">
                    <sending-settings></sending-settings>
                </b-tab>
                <b-tab :title="$t('routing.title')" v-if="canSetForwards">
                    <routing-settings></routing-settings>
                </b-tab>
                <b-tab :title="$t('autoresponders.title')" v-if="canSetAutoresponders">
                    <autoresponder-settings></autoresponder-settings>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import Passwords from '@/components/passwords';
import GeneralSettings from '@/components/generalSettings';
import RoutingSettings from '@/components/routingSettings';
const SendingSettings = () => import(/* webpackChunkName: "sendingSettings" */'@/components/sendingSettings');
const AutoresponderSettings = () =>
  import(/* webpackChunkName: "autoresponderSettings" */'@/components/autoresponderSettings');

export default {
  name: 'settings',
  components: { Passwords, GeneralSettings, SendingSettings, RoutingSettings, AutoresponderSettings },
  i18nOptions: { keyPrefix: 'settings' },
  data: function() {
    return {
      pages: ['general', 'passwords', 'sending', 'routing', 'autoresponders'],
      tabIndex: 0
    };
  },
  beforeRouteUpdate(to, from, next) {
    console.log('bru', to);
    this.tabSelected(to.params.page);
    next();
  },
  beforeRouteEnter(to, from, next) {
    console.log('bre', to);
    next(vm => {
      vm.tabSelected(to.params.page);
    });
  },
  methods: {
    tabSelected(page) {
      const index = this.pages.indexOf(page);
      console.log(index);
      this.tabIndex = index;
    },
    changeTab(tabIndex) {
      const page = this.pages[tabIndex];
      this.$router.push(`/settings/${page}`);
    }
  },
  computed: {
    canChangePassword() {
      return this.$store.state.settings.canchangepassword;
    },
    canSetForwards() {
      return this.$store.state.settings.cansetforwards;
    },
    canSetAutoresponders() {
      return this.$store.state.settings.allowchangeautoresponders;
    }
  }
};
</script>

<style lang="scss">
    .settingsPage {
        margin: 0 20px;
        display: flex;
        flex-direction: column;
        .card {
            overflow: hidden;
            .tabs {
                overflow: hidden;
                .tab-content {
                    overflow-y: auto;
                    height: calc(100% - 54px);
                }
            }
        }

    }

</style>
